import React from "react";
import { useSelector } from "react-redux";
import { TextField } from "@material-ui/core";
import { useI18n } from "../../hooks/useI18n";
import { AppState } from "../../store";
import { Market } from "../../models/Market";
import { Badge, Chip, Grid, InputAdornment, MenuItem } from "@material-ui/core";
import { useLoadIfEmpty } from "../../hooks/useLoadIfEmpty";
import { thunkFetchCurrentMarket } from "../../store/markets/actions";

interface DepositFeeEditorProps {
  value?: number;
  onChange: (val: any) => void;
}

export const DepositFeeEditor: React.FunctionComponent<
  DepositFeeEditorProps
> = ({ value, onChange }) => {
  let market = useSelector<AppState, Market>(s => s.currentMarket) || {};
  const { t } = useI18n();

  useLoadIfEmpty(!market?.currency && !market?.id, thunkFetchCurrentMarket);

  return (
    <>
      <TextField
        key={"deposit"}
        label={t("common.formFields.depositFee")}
        type="number"
        value={value ?? ""}
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              {market.currencySymbol}
            </InputAdornment>
          )
        }}
        onChange={(e: any) => onChange(e.target.value)}
      />
      {market.depositFees &&
        market.depositFees.length > 0 &&
        market.depositFees.map(p => (
          <Chip
            style={{ marginTop: 5, marginRight: 3 }}
            color={"primary"}
            size={"small"}
            label={`${p.amount} ${market.currencySymbol}`}
            onClick={() => onChange(p.amount)}
          />
        ))}
    </>
  );
};
